export default __webpack_public_path__ + "static/lifetime-ipad-2485677e13ba2de830ec02de6ebaedd4.jpg";